import Component from 'navigation/component/Component';
import { bindMethod } from 'helpers/bind';
import scroll from 'core/scroll';
import { clamp } from 'lodash-es';
class HomeDiptych extends Component {
    _fraction = 0;
    initialized() {
        super.initialized();
        this.slides = Array.from(this.el.querySelectorAll('.home-block-content__inner'));
        const b = this.el.getBoundingClientRect();
        this._bounds = {
            top: b.top,
            height: b.height
        };
    }
    bindEvents = (add) => {
        const method = bindMethod(add);
        window[method]('scroll', this.onPageScroll);
        this.refs.slider[method]('scroll', this.onScroll);
    };
    onScroll = () => {
        this._fraction = this.refs.slider.scrollWidth / 2;
        // const currentImage = Math.round(this.refs.slider.scrollLeft / this._fraction)
        const progress = this.refs.slider.scrollLeft / (this.refs.slider.scrollWidth - this.refs.slider.clientWidth);
        this.refs.track.style.transform = `translateX(${progress * (100) * 1}%)`;
    };
    onPageScroll = () => {
        this.slides.forEach((slide) => {
            const v = clamp((scroll.scrollTop() + window.innerHeight) - this._bounds.top, slide.clientHeight, this._bounds.height);
            slide.style.setProperty('--scroll', v + 'px');
        });
        const trackBottom = this.refs.trackWrapper.getBoundingClientRect().bottom;
        const elBottom = this.el.getBoundingClientRect().bottom;
        const diff = elBottom - trackBottom;
        if (diff < 300)
            this.refs.trackWrapper.classList.add('is-hidden');
        else
            this.refs.trackWrapper.classList.remove('is-hidden');
    };
    resize() {
        super.resize();
    }
}
export default HomeDiptych;
